import { get } from "lodash";
import React, { useContext, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { FeeRunContainer, ProgressBarFeeContainer } from "../../../containers";
import FeeRunDetailsCard from "../../../containers/Fee/FeeRunContainer/FeeRunDetailsCard";
import { ManageFeeProvider, manageFeeStore } from "../../../contexts";
import { withAppLayout } from "../../../hoc";
import { CREATE_FEE_MENU } from "../../../utils";
import { ManageFeeRoutes } from "../../../routes";

export const FeeRun = (props) => {
  const history = useHistory();
  const { state, dispatch } = useContext(manageFeeStore);
  return (
    <Row sm="12" className="h-100">
      <Col
        className="manage-master-column manage-menu-items"
        style={{ paddingRight: "0px", maxWidth: "23%" }}
      >
        <FeeRunDetailsCard />
      </Col>
      <Col className="app-outer-layout">
        {/* <FeeRunContainer /> */}
        <ManageFeeRoutes />
      </Col>
    </Row>
  );
};
const FeeRunWithProvider = (props) => {
  return (
    <ManageFeeProvider>
      <FeeRun {...props} />
    </ManageFeeProvider>
  );
};
export default withAppLayout(FeeRunWithProvider);
